export default __webpack_public_path__ + "static/media/ivan-torres-MQUqbmszGGM-unsplash.8db70efa.jpg";